<template>
  <div class="row px-4">
    <div class="form-group col-md-6 col-sm-12" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <first-name-field v-model="applicationData.first_name" :readonly="readonly" />
    </div>
    <div class="form-group col-md-6 col-sm-12" data-aos="fade-left" data-aos-duration="1500" data-aos-delay="200">
      <last-name-field v-model="applicationData.last_name" :readonly="readonly" />
    </div>
    <div class="form-group col-md-6 col-sm-12" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <email-field v-model="applicationData.email" :readonly="readonly" />
    </div>
    <div class="form-group col-md-6 col-sm-12" data-aos="fade-left" data-aos-duration="1500" data-aos-delay="200">
      <phone-field  v-model="applicationData.phone" :readonly="readonly" />
    </div>
  </div>
</template>
<script>

import FirstNameField from '@/shared/fields/first_name.vue'
import LastNameField from '@/shared/fields/last_name.vue'
import EmailField from '@/shared/fields/email.vue'
import PhoneField from '@/shared/fields/phone.vue'

export default {
  components: { FirstNameField, LastNameField, EmailField, PhoneField,
  },
  props: {
    readonly: {
      type: Boolean,
      required: true
    },
    applicationData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
